import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { toast } from "react-toastify";
import {
  faTimes,
  faCloudUploadAlt,
  faIdCard,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
function UploadINEModal({
  isOpen,
  toggle,
  handleLoadFile,
  id,
  deleteElement,
  file1,
  file2,
}) {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(file1);
  const [imgURL, setImgURL] = useState("");
  const [isImageValid, setIsImageValid] = useState(false);
  const [selectedImage2, setSelectedImage2] = useState(file2);
  const [imgURL2, setImgURL2] = useState("");
  const [isImageValid2, setIsImageValid2] = useState(false);
  useEffect(() => {
    setSelectedImage(file1);
    console.log(file1);
  }, [file1]);
  useEffect(() => {
    setSelectedImage2(file2);
    console.log(file2);
  }, [file2]);
  return (
    <Modal isOpen={isOpen} key={id}>
      <ModalBody>
        <div className="autoriaModal">
          <h3>{t("services.copyright.form.modals.ine.title")}</h3>
          {/* <FontAwesomeIcon
            icon={faTimes}
            className="closeButton"
            size="sm"
            onClick={toggle}
          /> */}
          <div className="modalContent--INE">
            <div>
              <div className="dropZoneMessage">
                <p>{t("services.copyright.form.modals.ine.text1")}</p>
              </div>
              {selectedImage !== null ? (
                <>
                  <div
                    className="INEpreview"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      alt="not fount"
                      width={280}
                      src={
                        selectedImage?.url
                          ? selectedImage?.url
                          : URL.createObjectURL(selectedImage)
                      }
                    />
                  </div>
                  <div className="selecteImageInfo">
                    <FontAwesomeIcon
                      icon={faIdCard}
                      size="2x"
                      color="#f37b33"
                      className="ImageIcon"
                    />
                    <div className="info">
                      <p>
                        {selectedImage?.name?.length > 25
                          ? `${selectedImage?.name?.slice(0, 25)}...`
                          : selectedImage?.name}
                      </p>

                      <span>
                        {String(selectedImage?.size / 1024 ** 2).slice(0, 5)} MB
                      </span>
                    </div>
                    <FontAwesomeIcon
                      icon={faTimes}
                      size={"1x"}
                      color="#9ea0a5"
                      className="ImageIcon"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelectedImage(null);
                        setIsImageValid(false);
                        deleteElement(`id${id}`);
                      }}
                    />
                    {selectedImage?.size / 1024 ** 2 >= 5 ? (
                      <span
                        style={{
                          position: "absolute",
                          bottom: "-25px",
                          left: "0px",
                          color: "rgb(219, 0, 0)",
                        }}
                      >
                        {t("services.copyright.form.modals.ine.size")}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                <div className="imageDropZoneDash--Parent">
                  <input
                    type="file"
                    name="ine1"
                    className="imageDropZoneDash"
                    accept="image/*"
                    onDrop={(event) => {
                      console.log(event.target.files[0]);
                      if (
                        event.target.files[0]?.type?.slice(0, 5) === "image"
                      ) {
                        setSelectedImage(event.target.files[0]);
                      } else {
                        toast.error("El Archivo debe ser de tipo Imagen");
                      }
                    }}
                    onChange={(event) => {
                      console.log(event.target.files[0]);
                      if (
                        event.target.files[0]?.type?.slice(0, 5) === "image"
                      ) {
                        setSelectedImage(event.target.files[0]);
                      } else {
                        toast.error("El Archivo debe ser de tipo Imagen");
                      }
                    }}
                  />

                  <FontAwesomeIcon
                    icon={faIdCard}
                    size="4x"
                    color="#f37b33"
                    className="ImageIcon"
                  />
                  <div className={"UploadImageLegend"}>
                    <FontAwesomeIcon icon={faCloudUploadAlt} color="#9ea0a5" />
                    <span>{t("services.copyright.form.modals.ine.drag")}</span>
                  </div>
                </div>
              )}
            </div>
            <div>
              <div className="dropZoneMessage">
                <p>{t("services.copyright.form.modals.ine.text2")}</p>
              </div>
              {selectedImage2 !== null ? (
                <>
                  <div
                    className="INEpreview"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      alt="not fount"
                      width={280}
                      src={
                        selectedImage2?.url
                          ? selectedImage2?.url
                          : URL.createObjectURL(selectedImage2)
                      }
                    />
                  </div>
                  <div className="selecteImageInfo">
                    <FontAwesomeIcon
                      icon={faIdCard}
                      size="2x"
                      color="#f37b33"
                      className="ImageIcon"
                    />
                    <div className="info">
                      <p>
                        {selectedImage2?.name?.length > 25
                          ? `${selectedImage2?.name?.slice(0, 25)}...`
                          : selectedImage2?.name}
                      </p>

                      <span>
                        {String(selectedImage2?.size / 1024 ** 2).slice(0, 5)}{" "}
                        MB
                      </span>
                    </div>
                    <FontAwesomeIcon
                      icon={faTimes}
                      size={"1x"}
                      color="#9ea0a5"
                      className="ImageIcon"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        setSelectedImage2(null);
                        setIsImageValid2(false);
                        deleteElement(`id2${id}`);
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    />
                    {selectedImage2?.size / 1024 ** 2 >= 5 ? (
                      <span
                        style={{
                          position: "absolute",
                          bottom: "-25px",
                          left: "0px",
                          color: "rgb(219, 0, 0)",
                        }}
                      >
                        {t("services.copyright.form.modals.ine.size")}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ) : (
                <div className="imageDropZoneDash--Parent">
                  <input
                    type="file"
                    name="ine2"
                    className="imageDropZoneDash"
                    accept="image/*"
                    onDrop={(event) => {
                      console.log(event.target.files[0]);
                      if (
                        event.target.files[0]?.type?.slice(0, 5) === "image"
                      ) {
                        setSelectedImage2(event.target.files[0]);
                      } else {
                        toast.error("El Archivo debe ser de tipo Imagen");
                      }
                    }}
                    onChange={(event) => {
                      console.log(event.target.files[0]);
                      if (
                        event.target.files[0]?.type?.slice(0, 5) === "image"
                      ) {
                        setSelectedImage2(event.target.files[0]);
                      } else {
                        toast.error("El Archivo debe ser de tipo Imagen");
                      }
                    }}
                  />

                  <FontAwesomeIcon
                    icon={faIdCard}
                    size="4x"
                    color="#f37b33"
                    className="ImageIcon"
                  />
                  <div className={"UploadImageLegend"}>
                    <FontAwesomeIcon icon={faCloudUploadAlt} color="#9ea0a5" />
                    <span>{t("services.copyright.form.modals.ine.drag")}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="buttons">
            <button className="first" onClick={toggle}>
              {t("services.copyright.form.modals.ine.close")}
            </button>
            <button
              className="second"
              onClick={() => {
                toggle();
                handleLoadFile({
                  id: "id" + id,

                  pic: selectedImage,
                });
                handleLoadFile({
                  id: "id2" + id,

                  pic: selectedImage2,
                });
              }}
              disabled={selectedImage === null || selectedImage2 === null}
              style={
                selectedImage === null || selectedImage2 === null
                  ? { opacity: 0.7 }
                  : {}
              }
            >
              {t("services.copyright.form.modals.ine.continue")}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default UploadINEModal;
